const userManagementPage = {
  en: {
    userManagementPage: {
      createFailed: "Failed to create user",
      updateFailed: "Failed to update user",
      confirmDeactivate: "Are you sure you want to deactivate this user?",
      deleteFailed: "Failed to delete user",
      title: "User Management",
      subtitle: "Manage user accounts and permissions",
      createUser: "Create User",
      createTitle: "Create New User",
      createDesc: "Add a new user to the system with specific role and permissions",
      fullName: "Full Name",
      email: "Email",
      password: "Password",
      role: "Role",
      organizationOptional: "Organization (Optional)",
      organizationPlaceholder: "Organization name",
      phoneOptional: "Phone (Optional)",
      organization: "Organization",
      phone: "Phone",
      cancel: "Cancel",
      totalUsers: "Total Users",
      activeUsers: "Active Users",
      searchPlaceholder: "Search by name, email, or organization...",
      filterByRole: "Filter by role",
      allRoles: "All Roles",
      filterByStatus: "Filter by status",
      allStatus: "All Status",
      active: "Active",
      inactive: "Inactive",
      users: "Users",
      usersDesc: "Manage all system users and their access levels",
      loadingUsers: "Loading users...",
      noUsers: "No users found",
      colUser: "User",
      colRole: "Role",
      colOrganization: "Organization",
      colStatus: "Status",
      colCreated: "Created",
      colActions: "Actions",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {{page}} of {{total}}",
      editUser: "Edit User",
      editDesc: "Update user information and permissions",
      saveChanges: "Save Changes",
      roles: {
        super_admin: "Super Admin",
        election_manager: "Election Manager",
        media: "Media",
        observer: "Observer",
        reporter: "Reporter",
        viewer: "Viewer"
      },
      roleDescriptions: {
        super_admin: "Full system access, can onboard and manage all users",
        election_manager: "ELECAM officials - manage elections and approve results",
        media: "Media houses - view and report on election results",
        observer: "Independent observers - view results and flag issues",
        reporter: "Field reporters - submit results from polling stations",
        viewer: "Public viewers - read-only access to results"
      }
    }
  },
  fr: {
    userManagementPage: {
      createFailed: "Échec de la création de l'utilisateur",
      updateFailed: "Échec de la mise à jour de l'utilisateur",
      confirmDeactivate: "Êtes-vous sûr de vouloir désactiver cet utilisateur ?",
      deleteFailed: "Échec de la suppression de l'utilisateur",
      title: "Gestion des utilisateurs",
      subtitle: "Gérez les comptes utilisateurs et leurs autorisations",
      createUser: "Créer un utilisateur",
      createTitle: "Créer un nouvel utilisateur",
      createDesc: "Ajoutez un nouvel utilisateur au système avec un rôle et des autorisations spécifiques",
      fullName: "Nom complet",
      email: "E-mail",
      password: "Mot de passe",
      role: "Rôle",
      organizationOptional: "Organisation (facultatif)",
      organizationPlaceholder: "Nom de l'organisation",
      phoneOptional: "Téléphone (facultatif)",
      organization: "Organisation",
      phone: "Téléphone",
      cancel: "Annuler",
      totalUsers: "Total des utilisateurs",
      activeUsers: "Utilisateurs actifs",
      searchPlaceholder: "Rechercher par nom, e-mail ou organisation...",
      filterByRole: "Filtrer par rôle",
      allRoles: "Tous les rôles",
      filterByStatus: "Filtrer par statut",
      allStatus: "Tous les statuts",
      active: "Actif",
      inactive: "Inactif",
      users: "Utilisateurs",
      usersDesc: "Gérez tous les utilisateurs du système et leurs niveaux d'accès",
      loadingUsers: "Chargement des utilisateurs...",
      noUsers: "Aucun utilisateur trouvé",
      colUser: "Utilisateur",
      colRole: "Rôle",
      colOrganization: "Organisation",
      colStatus: "Statut",
      colCreated: "Créé le",
      colActions: "Actions",
      previous: "Précédent",
      next: "Suivant",
      pageOf: "Page {{page}} sur {{total}}",
      editUser: "Modifier l'utilisateur",
      editDesc: "Mettez à jour les informations et les autorisations de l'utilisateur",
      saveChanges: "Enregistrer les modifications",
      roles: {
        super_admin: "Super administrateur",
        election_manager: "Responsable des élections",
        media: "Médias",
        observer: "Observateur",
        reporter: "Reporter",
        viewer: "Lecteur"
      },
      roleDescriptions: {
        super_admin: "Accès complet au système, peut intégrer et gérer tous les utilisateurs",
        election_manager: "Responsables d'ELECAM - gèrent les élections et approuvent les résultats",
        media: "Médias - consultent et rendent compte des résultats électoraux",
        observer: "Observateurs indépendants - consultent les résultats et signalent les problèmes",
        reporter: "Reporters de terrain - soumettent les résultats depuis les bureaux de vote",
        viewer: "Public - accès en lecture seule aux résultats"
      }
    }
  }
};

export default userManagementPage;
